import { computed, ref } from 'vue';
import type { Ref } from 'vue';
import {
	getToken,
	setToken,
	removeToken,
	hasActiveToken,
} from '@/scripts/Common';

// Singleton state — shared across all component instances
const token: Ref<string> = ref('');

const isAuthenticated = computed(() => token.value.length > 0);

const login = (newToken: string) => {
	setToken(newToken);
	token.value = newToken;
};

const logout = () => {
	removeToken();
	token.value = '';
};

const restoreFromStorage = () => {
	if (!hasActiveToken()) return;
	token.value = getToken();
};

export function useAuth() {
	return {
		token,
		isAuthenticated,
		login,
		logout,
		restoreFromStorage,
	};
}
